// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__F1sxj","heading":"Hero_heading__j16d0","subtitle":"Hero_subtitle__f3QGS","searchTitle":"Hero_searchTitle__rHZLG"};